import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export interface ContextMenuData {
    menuText: string;
    menuEvent: Function;
}

@Component({
    selector: 'ngx-loop-context-menu',
    templateUrl: './ngx-loop-context-menu.component.html',
    styleUrls: ['./ngx-loop-context-menu.component.css']
})
export class NgxLoopContextMenuComponent implements OnInit {

    @Input() contextMenuItems: Array<ContextMenuData>;

    @Input() topPosition: number = 0;
    @Input() leftPosition: number = 0;

    @Output() onMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
    }

    public onItemClick(event, menuItem: ContextMenuData): any {
        menuItem.menuEvent();
        this.onMenuItemClick.emit({event, menuItem});
    }

}
